import React from "react";
import styles from "./ota-loader.module.scss";
import Spinner from "@src/components/atoms/spinner/spinner";

const cssClassName = "ota-loader";
const OtaLoader = () => {
  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__spinner-wrapper`]}>
        <Spinner />
      </div>
    </div>
  );
};

export default OtaLoader;
